import React from 'react';

export default function ProgressBar({ progress, message, status = 'running' }) {
  const percentage = Math.round(progress * 100);

  const barColor = {
    running: 'bg-slate-400',
    completed: 'bg-emerald-400',
    failed: 'bg-red-400',
  }[status] || 'bg-slate-400';

  return (
    <div className="w-full">
      <div className="flex justify-between items-center mb-1.5">
        <p className="text-xs text-slate-500">{message}</p>
        <p className="text-xs text-slate-500 tabular-nums">{percentage}%</p>
      </div>
      <div className="w-full h-1 rounded-full overflow-hidden bg-slate-800">
        <div className={`h-full ${barColor} transition-all duration-300 ease-out`} style={{ width: `${percentage}%` }} />
      </div>
    </div>
  );
}
